
import { Button } from "@/components/ui/button";

interface SubmitButtonProps {
  isLoading: boolean;
  text: string;
  loadingText: string;
  disabled?: boolean;
}

export function SubmitButton({ isLoading, text, loadingText, disabled = false }: SubmitButtonProps) {
  return (
    <Button
      type="submit"
      className="w-full bg-brand-teal hover:bg-brand-teal/90 text-white font-medium mt-2"
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        <div className="flex items-center">
          <span className="mr-2">{loadingText}</span>
          <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : (
        text
      )}
    </Button>
  );
}
